// extracted by mini-css-extract-plugin
export default {"listframe":"Skills_listframe__xBWgC"};